// libs
import styled from 'styled-components'
// themes
import { colors } from 'themes'

export const Wrapper = styled.div`
  min-width: 200px;
  padding: 4px 0;
`

export const MenuItem = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 16px;
  cursor: pointer;
  color: ${colors.blue500};
  font-size: 14px;

  &:hover {
    background-color: ${colors.blue100};
  }
`

export const MenuItemLabel = styled.span`
  font-weight: 500;
`
